import React, { Component } from "react";
import CopyLinkModal from "../CopyLinkModal/CopyLinkModal";
import {
  FacebookShareButton,
  TwitterShareButton,
} from 'react-share';

import "./ShareLinks.css";

const shareTxt = 'VOTE NOW for your favourite Videos for Change entry on our website: https://www.videosforchange.org/vote - YOU could win a $100 Platypus Shoes voucher just for voting!'

export default class ShareLinks extends Component {
  state = {
    showCopyLinkModal: false
  };
  copyLink = e => {
    e.preventDefault();
    this.setState({
      showCopyLinkModal: true
    });
  };
  dismissCopyLinkModal = () => {
    this.setState({
      showCopyLinkModal: false
    });
  };

  render() {
    const url = this.props.url || window.location.href
    return (
      <div className="share-links">
        {this.props.caption && (
          <div className="caption">{this.props.caption}</div>
        )}
        <a className="button" href="/" onClick={this.copyLink}>Copy Link</a>
        <FacebookShareButton style={{display: 'inline-block'}} url={url} quote={shareTxt} ><span className="button -facebook">Facebook</span></FacebookShareButton>
        <TwitterShareButton style={{display: 'inline-block'}} url={url} title={shareTxt} ><span className="button -twitter">Twitter</span></TwitterShareButton>
        {this.state.showCopyLinkModal && (
          <CopyLinkModal
            url={this.props.url || window.location.href}
            handleDismiss={this.dismissCopyLinkModal}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ShareLinks/ShareLinks.js